module.exports = {
  services: {
    badge: "Servisler",
    title: "Servisler",
    subtitle: "Minimal servis sayfasi.",
    summaryTitle: "Icerik",
    summaryText: "Bu bolum daha sonra vaka ve bloklarla genisletilebilir.",
    summaryPoints: ["Denetim", "Destek", "Entegrasyon"],
    cardsTitle: "Alanlar",
    cardsSubtitle: "Veriler kart dizilerinden gelir.",
    cards: [
      { icon: "fas fa-network-wired", title: "Aglar", text: "Kisa aciklama." },
      { icon: "fas fa-cloud", title: "Bulut", text: "Kisa aciklama." },
      { icon: "fas fa-user-shield", title: "Guvenlik", text: "Kisa aciklama." }
    ],
    listTitle: "Calisma formati",
    listSubtitle: "Maddeler kolayca eklenebilir veya silinebilir.",
    listItems: ["Destek", "Kurulum", "Bakim"],
    stats: [
      { value: "3", label: "destek hatti" },
      { value: "24/7", label: "erisim" }
    ],
    ctaTitle: "Danismanlik ister misiniz?",
    ctaText: "Servis bolumu icin minimal yer tutucu.",
    primaryHref: "/pages/contact",
    primaryLabel: "Iletisim",
    secondaryHref: "/pages/portal",
    secondaryLabel: "Portal",
    processTitle: "",
    processSubtitle: "",
    process: [
      { num: "01", icon: "fas fa-search", title: "", text: "" },
      { num: "02", icon: "fas fa-drafting-compass", title: "", text: "" },
      { num: "03", icon: "fas fa-cogs", title: "", text: "" },
      { num: "04", icon: "fas fa-check-circle", title: "", text: "" }
    ]
  }
};